// UUID
import { v4 as uuidv4 } from 'uuid';

export default function TodosReducer(currentTodos, action) {
    switch (action.type) {
        case "add": {
            const newTodos = [...currentTodos,
            {
                title: action.payload.newTitle,
                details: action.payload.newDetails,
                id: uuidv4(),
                isCompleted: false,
            }]
            return newTodos;
        } case "check": {
            const newTodos = currentTodos.map((todo) => {
                return { ...todo, isCompleted: (todo.id === action.payload.newID ? !todo.isCompleted : todo.isCompleted) };
            })
            return newTodos;
        } case "update": {
            const newTodos = currentTodos.map((todo) => {
                return (todo.id === action.payload.newID) ?
                    action.payload.newTitle.trim() === "" ?
                        { ...todo, details: action.payload.newDetails }
                        :
                        { ...todo, title: action.payload.newTitle, details: action.payload.newDetails }
                    : todo;
            })
            return newTodos;
        } case "delete": {
            const newTodos = currentTodos.filter((todo) => {
                return todo.id !== action.payload.newID;
            })
            return newTodos;
        } default: {
            throw Error("invalid action: " + action.type);
        }
    }
}
